import React from 'react'

import { Box, Typography } from '@material-ui/core'
import { Ribbon } from './ribbon.component'

export interface ScoreRangeProps {
  backgroundColor?: string
  scoreRange: string
  title: string
}

export const ScoreRange: React.FC<ScoreRangeProps> = ({ scoreRange, title, backgroundColor = "#6b8e23" }) => {
  return (
    <Box position="relative" pt={6} pl={2} pr={2} pb={2} borderColor="black" border={2} borderRadius={8}>
      <Ribbon backgroundColor={backgroundColor}>{title}</Ribbon>
      <Typography variant="body1" style={{ fontWeight: 700, fontSize: 40, lineHeight: 1 }} noWrap>{scoreRange}</Typography>
      <Typography variant="body2" style={{ fontWeight: 700, fontSize: 16, lineHeight: 1 }} noWrap>SCORE RANGE</Typography>
    </Box>
  )
}